import { Animatespin, HeadingCom, JobsCom } from "../../components/index";
import JobsthemeColorsData from "../../js/jobsthemeColorsData";
import Functions from "./index.function";
const Jobs = () => {
  const {
    jobslisting,
    isLoading,
    handleJobClick,
    loadingJobId,
    handleSevedJob,
  } = Functions();
  return (
    <div className="xs:py-5 sm:py-6 xs:px-3 sm:px-6 lg:px-5 xl:px-10">
      <div className="">
        <HeadingCom to={"/job-listing"} title={"Jobs"} />
      </div>
      <div className="lg:pt-14 xs:pt-5 sm:pt-6">
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <>
            {jobslisting?.jobs?.length < 1 ? (
              <div className="flex items-center justify-center w-full">
                <p className="text-secondary">No jobs available</p>
              </div>
            ) : (
              <div className="grid xs:grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 xs:gap-y-3 sm:gap-5 xl:gap-10 3xl:gap-16">
                {jobslisting?.jobs.map((value, index) => (
                  <div key={index}>
                    <JobsCom
                      onClick={() => handleJobClick(value?.id)}
                      subtitle={value?.company?.name}
                      jobsTitle={value?.title}
                      jobsDis={value?.description?.split(".")[0] + "."}
                      timingbtnTitle={value?.job_types?.job_type}
                      salarybtnTitle={`${value?.salary_currency ?? ""}${
                        value?.salary_from
                      } - ${value?.salary_currency ?? ""}${value?.salary_to}`}
                      jobstheme={
                        JobsthemeColorsData[index % JobsthemeColorsData?.length]
                          .jobstheme
                      }
                      btntheme={
                        JobsthemeColorsData[index % JobsthemeColorsData?.length]
                          .btntheme
                      }
                      location={value?.country?.country}
                      navigate={() => handleJobClick(value?.id)}
                      loadingapi={loadingJobId === value?.id}
                      hide_salary={value?.hide_salary}
                      isSaved={value?.is_job_saved}
                      savedJob={() =>
                        handleSevedJob(value?.id, value?.is_job_saved)
                      }
                    />
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default Jobs;
